export const gestaoMunicipios = [
  {
    name: `Encontros`,
    config: "visualizaTodosEncontros",
    configPai: "encontros",
    link: "/encontros",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Municípios Eixos",
    config: "verMenuMunicipioEixos",
    link: "/municipioEixo",
    isMobile: true,
    icon: "mdi-file-document-box",
  },

  {
    name: "Municípios Temas",
    config: "verMenuMunicipioTemas",
    link: "/municipioTemasHabilitados",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Meus Encontros",
    config: "encontros",
    link: "/encontros",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
];

export const cadastros = [
  {
    name: "Unidades Regionais",
    config: "unidadesRegionais",
    link: "/ur",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Contratos",
    config: "verMenuContrato",
    link: "/contratos",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Temas",
    config: "temas",
    link: "/tema",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Eixos",
    config: "eixos",
    link: "/eixos",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Pacotes",
    config: "pacotes",
    link: "/pacote",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Perguntas",
    config: "perguntas",
    link: "/pergunta",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Medalhas",
    config: "medalas",
    link: "/medalha",
    isMobile: true,
    icon: "mdi-file-document-box",
  },

  {
    name: "Eventos",
    config: "eventos",
    link: "/eventos",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Categorias",
    config: "verMenuCategorias",
    link: "/categorias",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Instituição",
    config: "verMenuInstituicao",
    link: "/instituicao",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Faixas",
    config: "verMenuFaixas",
    link: "/faixas",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
];

export const menus = [
  {
    name: "Gestão de Territórios",
    link: "gestao-territorios/territorios",
    config: "menuGestaoTerritorios",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Educação Empreendedora",
    config: "verEducacaoEmpreendedora",
    link: "/municipio-escola",
    isMobile: true,
    icon: "mdi-file-document-box",
  },
  {
    name: "Gestão de Municípios",
    link: "",
    config: "",
    children: gestaoMunicipios,
  },
  {
    name: "Gestão de Cadastros",
    link: "",
    config: "",
    children: cadastros,
  },
];

export const configs = [
  {
    name: "Configurações",
    config: "configuracao",
    link: `/configuracoes`,
    isMobile: true,
    icon: "mdi-settings",
  },
  {
    name: "Grupos",
    config: "grupo",
    link: `/groups`,
    isMobile: true,
    icon: "mdi-settings",
  },
  {
    name: "Projetos e Soluções",
    config: "projetoseSolucoes",
    link: "/termo-referencia",
    isMobile: true,
    icon: "mdi-settings",
  },
  {
    name: "Processos de pagamentos",
    config: "processosPagamentos",
    link: "/gestao-pagamento",
    isMobile: true,
    icon: "mdi-settings",
  },
  {
    name: "Tipo Solução",
    config: "editarTipoSolucao",
    link: "/tipoSolucao",
    isMobile: true,
    icon: "mdi-settings",
  },

  {
    name: "Meus Processos de Pagamentos",
    config: "meusProcessosPagamentos",
    link: `/gestao-pagamento/usuario/userId`,
    isMobile: true,
    icon: "mdi-settings",
  },
  {
    name: "Sala do Empreendedor",
    config: "salaEmpreendedor",
    link: `/sala-principal`,
    isMobile: true,

    icon: "mdi-settings",
  },
  {
    name: "Usuários",
    config: "usuarios",
    link: "/usuario",
    isMobile: true,
    icon: "mdi-settings",
  },
];

export const relatorios = [
  {
    name: "Analisar Relatórios",
    config: "podeAnalisarRelatorio",
    link: "/analisar-relatorios",
    configPai: "analisarRelatorios",
    isMobile: true,
    icon: "mdi-view-dashboard",
  },
  {
    name: "Meus Relatórios",
    config: "verMeusRelatorios",
    link: "/analisar-relatorios",
    configPai: "analisarRelatorios",
    isMobile: true,
    icon: "mdi-view-dashboard",
  },

  {
    name: "Analisar Relatórios Admin",
    config: "analisarRelatoriosAdministrativos",
    link: "/analisar-relatorios-administrativos",
    configPai: "analisarRelatoriosAdministrativos",
    isMobile: true,
    icon: "mdi-view-dashboard",
  },

  {
    name: "Meus Relatórios Admin",
    config: "podeAnalisarRelatorioAdmin",
    link: "/analisar-relatorios-administrativos",
    configPai: "analisarRelatoriosAdministrativos",
    isMobile: true,
    icon: "mdi-view-dashboard",
  },
  {
    name: "Dashboard",
    config: "dashboardAdministrativo",
    link: "/dashboard-administrativo2",
    isMobile: true,
    icon: "mdi-view-dashboard",
  },
];

export const menu = [
  {
    name: "Início",
    link: "/cidade",
  },
  {
    name: "Gestão",
    children: menus,
    link: "",
  },

  {
    name: "Administração",
    children: configs,
    link: "",
  },
  {
    name: "Relatórios",
    children: relatorios,
    link: "",
  },
];
